var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomDocUpload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    id: "i1x1y6u9oa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#i1x1y6u9oa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.817 1c.65 0 1.275.261 1.735.722l4.295 4.294c.46.456.721 1.085.721 1.735V24.75c0 1.356-1.1 2.456-2.456 2.456h-7.475a8.542 8.542 0 0 0 2.14-2.457h5.335V10.01h-5.324c-.68 0-1.228-.548-1.228-1.229V3.457h-8.19v8.79a8.452 8.452 0 0 0-2.458 1.041l.002-9.831C7.914 2.1 9.014 1 10.37 1h10.446zm.2 2.656v3.896h3.895l-3.895-3.896z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm.373 3.02a.6.6 0 0 0-.843.098l-1.674 2.109a.6.6 0 0 0 .47.973h1.032a.6.6 0 0 0-.031.192v5.331a.6.6 0 0 0 .6.6h.146a.6.6 0 0 0 .6-.6v-5.331a.6.6 0 0 0-.031-.192h1.032a.6.6 0 0 0 .47-.973l-1.674-2.11a.6.6 0 0 0-.097-.096z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 20c-.09-3.59-1.535-4.934-5.125-4.764 3.59-.17 4.965-1.646 4.875-5.236.09 3.59 1.535 4.934 5.125 4.764-3.59.17-4.965 1.646-4.875 5.236zM7.125 29C7.035 25.41 5.59 24.066 2 24.236c3.59-.17 4.965-1.646 4.875-5.236.09 3.59 1.535 4.934 5.125 4.764-3.59.17-4.965 1.646-4.875 5.236z",
    fill: "#F2BD66",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomDocUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-doc-upload.e1d99eeae66c41ac127ef6585d64b8c2.svg";